import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {DiagnosticAssistance} from '@/views/services/diagnosticAssistance/interfaces';
import {EntityDBModule} from '../entities/entityDBStorageModule';

/*
    Динамический модуль хранилища vuex для журнала Помощь в диагностике
*/

const moduleName = 'diagnosticAssistanceModule';

function transformGet(elem: any): DiagnosticAssistance {
  return {
    id: elem.id,
    name: elem.name,
    diagrams: elem.diagrams,
    columns: elem.columns,
  };
}

function transformCreateEdit(elem: any): DiagnosticAssistance {
  return {
    name: elem.name,
    diagrams: elem.diagrams,
    columns: elem.columns,
  };
}

function transformSave(model: DiagnosticAssistance): any {
  return {
    id: model.id,
    name: model.name,
    diagrams: model.diagrams,
    columns: model.columns,
  };
}

function getCreate(): DiagnosticAssistance {
  return {
    name: '',
    diagrams: [],
    columns: [
      {
        id: '1',
        size: 50,
      },
    ],
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class DiagnosticAssistanceModule extends EntityDBModule {
  protected etitieName = 'diagnostic_assistance_settings';
  protected routeName = '/profile';

  get all(): DiagnosticAssistance[] {
    return super.all as DiagnosticAssistance[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: DiagnosticAssistance}> {
    return super.create(getCreate, transformCreateEdit) as Promise<{data: DiagnosticAssistance}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: DiagnosticAssistance}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: DiagnosticAssistance}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: DiagnosticAssistance) {
    return super.save(model, transformSave);
  }
}

export default getModule(DiagnosticAssistanceModule);
